import React from 'react';
import PortfolioNavbar from './navbar/portfolioNav';

const PortfolioHeader = () => (
  <div>
      <PortfolioNavbar />
  </div>
);

export default PortfolioHeader;
